import { render, staticRenderFns } from "./CoachReviewList.vue?vue&type=template&id=2fed4537&scoped=true&lang=pug"
import script from "./CoachReviewList.vue?vue&type=script&lang=js"
export * from "./CoachReviewList.vue?vue&type=script&lang=js"
import style0 from "./CoachReviewList.vue?vue&type=style&index=0&id=2fed4537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed4537",
  null
  
)

export default component.exports